import script from "./SharePage.vue?vue&type=script&setup=true&lang=js"
export * from "./SharePage.vue?vue&type=script&setup=true&lang=js"

import "./SharePage.vue?vue&type=style&index=0&id=89a2a7b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89a2a7b2"]])

export default __exports__